import { InjectionToken } from '@angular/core';
import type { MonitoringAdapterLoader } from './models';

export const MONITORING_ADAPTER_LOADER =
    new InjectionToken<MonitoringAdapterLoader>('Monitoring adapter loader', {
        providedIn: 'root',
        factory: () => async (instrumentationKey) => {
            const { createApplicationInsightsAdapter } =
                await import('./application-insights.adapter');
            return createApplicationInsightsAdapter(instrumentationKey);
        },
    });
